import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import confirm from './plugins/confirm'
import 'font-awesome/css/font-awesome.min.css'
import '@mdi/font/css/materialdesignicons.css'

import './styles/us-common.css'

import moment from 'moment'
import 'moment/locale/zh-cn' // 中文语言
Vue.prototype.$moment = moment

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

// import appHelper from '@/utils/AppHelper'

// Vue.use(Viewer) 默认配置写法
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
    toolbar: true,
    url: 'data-original'
  }})

import clipboard from 'clipboard';
// 注册到vue原型上
Vue.prototype.$clipboard = clipboard;

import api from './api/install'
Vue.use(api)

import stores from './stores'
Vue.prototype.$store = stores

import wx from 'weixin-js-sdk'
Vue.prototype.$wx = wx

import AppHelper from '@/utils/AppHelper.js'
Vue.prototype.$AppHelper = AppHelper

import util from '@/utils/index.js'
Vue.prototype.$util = util

import history from '@/utils/History.js'
Vue.prototype.$history = history

import Common from '@/utils/Common.js'
Vue.prototype.$Common = Common

Vue.prototype.$confirm = confirm

import 'animate.css'

Vue.prototype.$iconPath = '/res/icon/iot_v2'

Vue.config.productionTip = false


// // 系统错误捕获
// const errorHandler = (error, vm, info) => {
//   console.error('抛出全局异常');
//   console.error(vm);
//   console.error(error);
//   console.log(error);
//   console.log(`Error: ${error.toString()}\nInfo: ${info}`);

// }

// Vue.config.errorHandler = errorHandler;
// Vue.prototype.$throw = (error) => errorHandler(error, this);

Vue.config.errorHandler = function(err, vm, info) {
  console.error('抛出全局异常');
  console.error(vm);
  console.error(err);
  console.error(info);

  // var obj = {
  //   url: window.location.href,
  //   message: err.message,
  //   stack: err.stack
  // }
}


new Vue({
  vuetify,
  router,
  stores,
  render: h => h(App)
}).$mount('#app')
